
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"16","height":"16","viewBox":"0 0 16 16"}},_vm.$listeners),[_c('path',{attrs:{"d":"M1 8a7 7 0 0 0 12.041 4.854l.035-.036a1 1 0 1 0-1.476-1.35A5 5 0 1 1 12.9 7h-1.3a.254.254 0 0 0-.174.073.251.251 0 0 0 0 .354l3.146 3.15a.246.246 0 0 0 .177.073.249.249 0 0 0 .251-.25V8A7 7 0 0 0 1 8"}})])}
var staticRenderFns = []

    export default {
      render: render,
    }
  